import React from "react";
import { FormattedMessage } from "react-intl";
import css from './PageTitle.module.css'

const PageTitle = props => {
    const isTribes = typeof window !== 'undefined' && window.location.pathname == "/tribes"
    return <h1 className={css.title}><FormattedMessage id={!isTribes ? "ListingPage.PageTitle.tours" : "ListingPage.PageTitle.tribes"} /></h1>
}

export default PageTitle